<template>
  <smd-one-col-layout content-styles="full-width">
    <smd-header slot="header" nav>
      <span :class="navLeftIcon"
            slot="left-actions"
            @click="goBack"/>
      <text-string :label-id="programTitle"/>
      <span class="ns-icon-ico001"
            slot="right-actions">
        <span class="path1"></span>
        <span class="path2"></span>
      </span>
    </smd-header>

    <smd-loader v-if="loading" :image="$options.Logo"/>

    <component :is="activeComponent"
               :loading="loading"
               @set-active-step="setActiveStep"/>

  </smd-one-col-layout>
</template>

<script>
  import {mapActions} from 'vuex';
  import {mapFields} from 'vuex-map-fields';
  import Routes from '@/router/routes';
  import Logo from '@/assets/icons/now-serving-heart.svg';

  import programFreestyleLibreDetails from '@/views/program/program-freestylelibre/freestylelibre-details';
  import programFreestyleLibreSignUp from '@/views/program/program-freestylelibre/freestylelibre-signup';
  import programFreestyleLibreConfirmation from '@/views/program/program-freestylelibre/freestylelibre-confirmation';

  import {QuestionsApiService} from '@/services/program';

  import {isFSLEProgramId} from '@/reference/coupon';
  import {
    PROGRAM_FREESTYLELIBRE_DETAILS,
    PROGRAM_FREESTYLELIBRE_SIGNUP,
    PROGRAM_FREESTYLELIBRE_CONFIRMATION,
    FSLE_QID,
  } from '@/reference/program';

  import {
    ACTION_RESET_PROGRAM_STATE,
  } from '@/store/types';

  export default {
    name: 'root-program',
    data() {
      return {
        activeStep: null,
        programTitle: '',
      }
    },
    computed: {
      ...mapFields('program', {
        programCoupon: 'coupon',
        programDetails: 'program',
        loading: 'loadingstate',
      }),
      navLeftIcon() {
        if (isFSLEProgramId(this.programCoupon.programid)) {
          return this.activeStep === PROGRAM_FREESTYLELIBRE_CONFIRMATION ? 'ns-icon-ico027' : 'ns-icon-ico028';
        }

        return 'ns-icon-ico028';
      },
      activeComponent() {
        const freestyleStep = {
          [PROGRAM_FREESTYLELIBRE_DETAILS]: programFreestyleLibreDetails,
          [PROGRAM_FREESTYLELIBRE_SIGNUP]: programFreestyleLibreSignUp,
          [PROGRAM_FREESTYLELIBRE_CONFIRMATION]: programFreestyleLibreConfirmation,
        }

        if (isFSLEProgramId(this.programCoupon.programid)) return freestyleStep[this.activeStep];

        return null;
      }
    },
    created() {
      if (isFSLEProgramId(this.programCoupon.programid)) {
        this.fetchProgramQuestion(FSLE_QID);
        this.activeStep = PROGRAM_FREESTYLELIBRE_DETAILS;
        this.programTitle = 'txt1448';
      }
    },
    destroyed() {
      this.resetState();
    },
    methods: {
      ...mapActions('program', {
        resetState: ACTION_RESET_PROGRAM_STATE,
      }),
      goBack() {
        this.$router.go(-1);
      },
      setActiveStep(step) {
        this.activeStep = step;
      },
      async fetchProgramQuestion(questionId) {
        this.loading = true;

        try {
          const {data} = await QuestionsApiService.fetchQuestion(questionId);
          if (data) {
            this.programDetails = data.data;
            this.programDetails.questions = this.programDetails.questions
              .map((question) => {
                return {
                  ...question,
                  chosen_answer: {},
                }
              });
          }
          this.loading = false;
        } catch (error) {
          this.loading = false;
          this.$router.push({name: Routes.ERROR_ROUTE});
        }
      },
    },
    Logo,
  }
</script>

<style>

</style>